<script>
import validationMessages from "@/components/validations";
import { required } from "vuelidate/lib/validators";
import Monitor from "@/services/Monitor";
import Aws from "../../../../services/Aws";

export default {
  components: {
    validationMessages,
  },
  props: {
    tenant: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      tryingToSubmit: false,
      submitted: false,
      tenants: [],
      instances: [],
      selectedTenant: "",
      command: "",
      expression: "",
      params: "",
      laravel_expression: "",
      background: 1,
      environment: "prod",
      description: "",
      server: "",
      active: 1,
      critical: 0,
      envs: ["prod", "dev"],
      csrf_token: localStorage.getItem("csrf_token"),
    };
  },
  validations: {
    command: { required },
    expression: { required },
    description: { required },
  },
  methods: {
    onShow() {
      this.getTenants();
      this.getInstances();
    },
    resetProps() {
      this.submitted = false;
      this.tenants = [];
      this.command = "";
      this.expression = "";
      this.params = "";
      this.laravel_expression = "";
      this.background = 1;
      this.environment = "prod";
      this.description = "";
      this.server = "";
      this.active = 1;
      this.critical = 0;
      this.selectedTenant = "";
      this.instances = [];
    },
    refreshData() {
      this.$emit("onRefresh"); //event from parent
    },
    closeModal() {
      this.showModal = false;
    },
    getTenants() {
      Monitor.getTenants()
        .then((response) => {
          this.tenants = response.data.tenants;
        })
        .catch((error) => {});
    },
  async getInstances() {
      try {
        const response = await Aws.getInstances();
        this.instances = response.data.data.filter(
          (item) => item.State === "running" && item.user_tags !== null ? item.user_tags.includes("cron") : false
        );
      } catch (error) {
        console.log(error, "error");
      }
    },

    createCronTask() {
      this.tryingToSubmit = true;
      this.submitted = true;
      this.tryingToSubmit = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.tryingToSubmit = false;
        return;
      }
      let formData = new FormData();
      formData.append("command", this.command);
      formData.append("tenant", this.selectedTenant);
      formData.append("params", this.params);
      formData.append("expression", this.expression);
      formData.append("laravel_expression", this.laravel_expression);
      formData.append("background", this.background);
      formData.append("environment", this.environment);
      formData.append("description", this.description);
      formData.append("server", this.server);
      formData.append("active", this.active);
      formData.append("critical", this.critical);

      Monitor.addCronScheduleTask(formData)
        .then((response) => {
          const res = response.data ? response.data : false;
          const error = response.data.error ? response.data.error : "";
          if (res) {
            this.successmsg("Schedule Task Created!");
            this.refreshData();
            this.closeModal();
          } else {
            this.failedmsg("Failed to create new schedule task!");
          }
        })
        .catch((error) => {
          const resData = error.response.data.error
            ? error.response.data.error
            : "Failed";
          const errorMsg = Array.isArray(resData) ? resData[0] : resData;
          this.failedmsg(errorMsg);
        })
        .finally(() => {
          this.tryingToSubmit = false;
        });
    },
  },
};
</script>

<template>
  <b-modal
    id="add_cron_schedule_task"
    size="md"
    v-model="showModal"
    @shown="onShow"
    @hidden="resetProps"
    title="Add New Cron Scheduled Task"
    title-class="font-18"
  >
    <form @submit.prevent="createCronTask()">
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label class="control-label form-label">Command *</label>
            <b-form-input
              v-model="command"
              :class="{
                'is-invalid': submitted && $v.command.$error,
              }"
            ></b-form-input>
            <validationMessages
              v-if="submitted"
              :fieldName="'Command'"
              :validationName="$v.command"
            ></validationMessages>
          </div>
          <div class="mb-3">
            <label class="control-label form-label">Tenant</label>
            <select
              v-model="selectedTenant"
              class="form-control form-select"
              name="option"
              type="select"
            >
              <option v-for="tenant in tenants" :key="tenant" :value="tenant">
                {{ tenant }}
              </option>
            </select>
          </div>

          <div class="mb-3">
            <label class="control-label form-label">Params</label>
            <b-form-input v-model="params"></b-form-input>
          </div>
          <div class="mb-3">
            <label class="control-label form-label">Expression *</label>
            <b-form-input
              v-model="expression"
              :class="{
                'is-invalid': submitted && $v.expression.$error,
              }"
            ></b-form-input>
            <validationMessages
              v-if="submitted"
              :fieldName="'Expression'"
              :validationName="$v.expression"
            ></validationMessages>
          </div>
          <div class="mb-3">
            <label class="control-label form-label">Laravel Expression</label>
            <b-form-input v-model="laravel_expression"></b-form-input>
          </div>
          <div class="col-sm-12 col-md-4">
            <label class="control-label form-label">Background</label>
            <b-form-checkbox-group>
              <div class="form-check form-switch form-switch-lg mb-3">
                <input
                  v-model="background"
                  type="checkbox"
                  class="form-check-input"
                  id="switch1"
                  true-value="1"
                  false-value="0"
                />
              </div>
            </b-form-checkbox-group>
          </div>
          <div class="mb-3">
            <label class="control-label form-label">Environment</label>
            <select
              v-model="environment"
              class="form-control form-select"
              name="option"
              type="select"
            >
              <option v-for="env in envs" :key="env" :value="env">
                {{ env }}
              </option>
            </select>
          </div>
          <div class="mb-3">
            <label class="control-label form-label">Description *</label>
            <b-form-input
              v-model="description"
              :class="{
                'is-invalid': submitted && $v.description.$error,
              }"
            ></b-form-input>
            <validationMessages
              v-if="submitted"
              :fieldName="'Description'"
              :validationName="$v.description"
            ></validationMessages>
          </div>
          <div class="mb-3">
            <label class="control-label form-label">Server</label>
            <select
              v-model="server"
              class="form-control form-select"
              name="option"
              type="select"
            >
              <option
                v-for="instace in instances"
                :key="instace.InstanceId"
                :value="instace.InstanceId"
              >
                {{
                  instace.Tags[0].Key !== "Name"
                    ? ""
                    : `${instace.InstanceId} |`
                }}
                {{
                  instace.Tags[0].Key === "Name"
                    ? instace.Tags[0].Value
                    : instace.InstanceId
                }}
              </option>
            </select>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-4">
              <label class="control-label form-label">Active</label>
              <b-form-checkbox-group>
                <div class="form-check form-switch form-switch-lg mb-3">
                  <input
                    v-model="active"
                    type="checkbox"
                    class="form-check-input"
                    true-value="1"
                    false-value="0"
                  />
                </div>
              </b-form-checkbox-group>
            </div>

            <div class="col-sm-6 col-md-4">
              <label class="control-label form-label">Critical</label>
              <b-form-checkbox-group>
                <div class="form-check form-switch form-switch-lg mb-3">
                  <input
                          v-model="critical"
                          type="checkbox"
                          class="form-check-input"
                          true-value="1"
                          false-value="0"
                  />
                </div>
              </b-form-checkbox-group>
            </div>
          </div>

        </div>
      </div>
      <input type="hidden" name="csrf_token" v-model="csrf_token" />
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button
        variant="primary"
        @click="createCronTask"
        :disabled="tryingToSubmit"
      >
        <b-spinner v-show="tryingToSubmit" small></b-spinner>
        Submit
      </b-button>
    </template>
  </b-modal>
</template>
